<template>
  <div>
    <base-title-bar
      :engOne="'RISK'"
      :engTwo="'CONTROL'"
      :engTitle="'风险控制'"
    ></base-title-bar>
    <div class="risk_box">
      <ul>
        <li v-for="(r, index) in riskCont" :key="index">{{ r }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Riskcontrol",
  data() {
    return {
      riskCont: [
        "公司具有很强的风控意识，体现在投研和运行的各个方面，在策略组合、产品设立、产品运行的时候分别进行，并设有专人负责整个环节。",
        "公司具备较完备的风险控制制度，目的在于保证经营运作符合公司的发展规划；它是在充分考虑内外部环境的基础上，通过建立组织机制、运用管理方法、实施操作程序与控制措施而形成的系统。",
        "具体分为：策略风控、产品风控和交易风控。",
      ],
    };
  },
};
</script>

<style  lang="scss" scoped>
.risk_box {
  width: 1000px;
  margin: 10px auto;
  background-color: #fff;
  margin: 10px auto 0 auto;
  padding: 20px;
  font-size: 16px;
  line-height: 30px;
  min-height: 300px;
  font-family: "Alibaba Sans Light", Arial;
  ul {
    list-style-type: square;
  }
}
</style>